import { memo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setBasicFilters } from '@/redux/store/actions/search';
import GuestCountMobile from './guestCountMobile/GuestCountMobile';
import useSearchParams from '@/components/search/hooks/useSearchParams';
import useDevice from '@/hooks/useDevice';
import FilterChips from '../reusabe/filterChips/FilterChips';
import Drawer from '@/components/UI/drawer/Drawer';
import useDrawer from '@/hooks/useDrawer';
import Box from '@/components/UI/box/Box';
import styles from './GuestCount.module.scss';
import Menu from '@/components/UI/menu/Menu';
import { useRouter } from 'next/router';
const GuestCount = () => {
  const router = useRouter();
  const {
    drawerOpen,
    drawerClose,
    isDrawerOpen
  } = useDrawer();
  const open = isDrawerOpen('GUEST_COUNT');
  const {
    guests,
    checkin,
    checkout
  } = useSelector(state => state.basicFilters);
  const {
    isMobile
  } = useDevice();
  const dispatch = useDispatch();
  const closeRef = useRef<any>(null);
  const handleClick = () => {
    if (open) {
      drawerClose();
    } else {
      drawerOpen('GUEST_COUNT');
    }
  };
  const setValue = (value: number) => {
    dispatch(setBasicFilters({
      checkin,
      checkout,
      guests: value
    }));
  };
  const submitData = count => {
    const pageContentSet = {
      '/all-boomgardi': {
        boomgardi: 1
      },
      '/all-cottage': {
        cottage: 1
      }
    };
    const pageQuery = pageContentSet[router.pathname] || {};
    router.push({
      pathname: '/search',
      query: {
        ...pageQuery,
        ...router.query,
        guests: count
      }
    });
  };
  const resetFilter = (e: React.FormEvent, shouldClose: boolean = true) => {
    e.stopPropagation();
    dispatch(setBasicFilters({
      guests: '1',
      checkin,
      checkout
    }));
    if (shouldClose) {
      const {
        guests,
        ...restQueries
      } = router.query;
      const pageContentSet = {
        '/all-boomgardi': {
          boomgardi: 1
        },
        '/all-cottage': {
          cottage: 1
        }
      };
      const pageQuery = pageContentSet[router.pathname] || {};
      router.push({
        pathname: '/search',
        query: {
          ...pageQuery,
          ...restQueries
        }
      });
    }
  };
  return <Box className={styles['filter-item-wrapper']} data-sentry-element="Box" data-sentry-component="GuestCount" data-sentry-source-file="GuestCount.tsx">
      <FilterChips type="secondary" checked={!!Number(router.query.guests)} handleClick={handleClick} handleClean={resetFilter} label={Number(router.query.guests) ? `${router.query.guests} نفر` : 'تعداد نفرات'} startIcon={'profile-2user'} endIcon={true} name="guest_num_filter" id="guest-number-chips" data-sentry-element="FilterChips" data-sentry-source-file="GuestCount.tsx" />
      {!isMobile ? <Menu ref={closeRef} id="guest-count" open={open} handleClose={drawerClose} className={styles['filter-item-container']} menuButtonId="guest-number-chips">
          <GuestCountMobile submitData={submitData} resetFilter={resetFilter} onClose={drawerClose} value={Number(router.query?.guests) || 1} setValue={setValue} hasGuestCount={!!Number(router.query.guests)} />
        </Menu> : <Drawer open={isDrawerOpen('GUEST_COUNT')} onClose={drawerClose}>
          <GuestCountMobile submitData={submitData} resetFilter={resetFilter} onClose={drawerClose} value={Number(router.query?.guests) || 1} setValue={setValue} hasGuestCount={!!Number(router.query.guests)} />
        </Drawer>}
    </Box>;
};
export default memo(GuestCount);